import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { WidgetID } from '../../models/widget.model';
import { SortDescriptor } from '@progress/kendo-data-query';

// identifier
export const WIDGET_SORT_SLICE_ID = 'widgetSort';

interface WidgetSortStateModel {
  [key: WidgetID]: SortDescriptor[];
}

interface WidgetFilterActionPayload {
  id: WidgetID;
  sort: SortDescriptor[];
}

// default state
const initialState: WidgetSortStateModel = {};

const defaultSort: SortDescriptor[] = [];

//slice
const widgetSortSlice = createSlice({
  name: WIDGET_SORT_SLICE_ID,
  initialState,
  reducers: {
    setWidgetSort: (
      state: WidgetSortStateModel,
      action: PayloadAction<WidgetFilterActionPayload>
    ) => {
      state[action.payload.id] = action.payload.sort;
    },
    clearWidgetSort: (state: WidgetSortStateModel, action: PayloadAction<WidgetID>) => {
      state[action.payload] = defaultSort;
    },
    clearPageLevelSort: (state: WidgetSortStateModel) => {
      // eslint-disable-next-line
      state = {};
    },
  },
});

//selectors

export const selectWidgetSort = createSelector(
  [
    (state: RootState): WidgetSortStateModel => state.widgetSort,
    (state: RootState, widgetId: WidgetID) => widgetId,
  ],
  (widgetFilter, widgetId) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return widgetFilter[widgetId] ?? defaultSort;
  }
);

//actions
export const { setWidgetSort, clearWidgetSort, clearPageLevelSort } = widgetSortSlice.actions;

//reducer
export default widgetSortSlice;
